import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ConstsHelper } from '../../../../helpers/consts.helper';
import { CustomerService } from '../../../account/services/customer.service';
import { select, Store } from '@ngrx/store';
import { GetAlertMessage } from '../../../shared/store/actions/alert-message.actions';
import { ECardsActions, GetCards, GetCardsSuccess } from '../../../account/store/actions/cards.actions';
import { Actions, ofType} from '@ngrx/effects';
import { CardInterface } from '../../../account/models/card.interface';
import { PaymentDetailsInterface } from '../../../shared/models/payment-details.interface';
import { AlertMessageInterfaceState } from '../../../shared/store/state/alert-message.state';

@Component({
  selector: 'app-account-bank-information',
  templateUrl: './account-bank-information.component.html',
  styleUrls: ['./account-bank-information.component.css'],
  standalone: false
})
export class AccountBankInformationComponent implements OnInit {
  @Output()
  accountBankInformation = new EventEmitter<any>();
  hasSelectedCard: CardInterface|null;
  form: FormGroup;
  formSubmitted: boolean;
  selectedPaymentMethod: string;
  paymentDetailsInterface: PaymentDetailsInterface;
  errors: any = {
    iban: {
      required: `L'IBAN est obligatoire.`,
      pattern: `L'IBAN saisie n'est pas valide.`
    },
    bic: {
      required: `Le BIC est obligatoire.`,
      pattern: `Le BIC saisie n'est pas valide.`
    }
  };
  genSepa: boolean;

  constructor(
      private formBuilder: FormBuilder,
      private actions$: Actions,
      private customerService: CustomerService,
      public store: Store<any>
  ) { }

  ngOnInit() {
    this.formSubmitted = false;
    this.genSepa = false;
    this.hasSelectedCard = null;
    this.selectedPaymentMethod = 'iban';
    this.store.dispatch(new GetCards());
    this.actions$.pipe(ofType(ECardsActions.GetCardsSuccess)).subscribe((result: GetCardsSuccess) => {
      if (null != result.payload) {
        this.hasSelectedCard = result.payload.find(card => card.isSelected === true);
      }
    });
    this.store.pipe(select(ConstsHelper.REDUCER_ALERT_MESSAGES)).subscribe((response: AlertMessageInterfaceState) => {
      if (response.alert != null && (response.alert.message === ConstsHelper.CONFIRMATION_MESSAGE_SAVE_PAYMENT_CARD || response.alert.message === ConstsHelper.ERROR_MESSAGE_SAVE_PAYMENT_CARD)) {
        this.goNexStep();
      }
    });
    this.paymentDetailsInterface = {
      errorMessage: ConstsHelper.ERROR_MESSAGE_SAVE_PAYMENT_CARD,
      procedureCode:  ConstsHelper.PROCEDURE_PAYMENT_METHOD_CHANGE,
      redirectLink: null,
      type: 'nouvelle_carte',
      procedureType: 'account',
      externalId: null,
      selectedLine: null,
      payload: {routeValue: 'cb_pay_method_change'},
      amount: 1
    } as PaymentDetailsInterface;
    this.initForm();
  }

  setSelectedPaymentMethod(paymentMethod: string) {
    this.selectedPaymentMethod = paymentMethod;
  }

  initForm() {
    this.form = this.formBuilder.group({});
    this.form = new FormGroup({
      iban: new FormControl('', []),
      bic: new FormControl('', [Validators.pattern(ConstsHelper.bicPattern)]),
    });
  }

  submit() {
    this.formSubmitted = true;
    if (this.form.valid) {
      if (this.form.get('iban').value !== '') {
        if ([null, undefined, ''].indexOf(this.form.get('bic').value) !== -1) {
          this.store.dispatch(new GetAlertMessage({
            message: 'Le BIC est obligatoire.',
            code: 400
          }));
        } else if (!this.genSepa) {
          this.store.dispatch(new GetAlertMessage({
            message: 'Veuillez cocher la case pour la génération de mandat SEPA.',
            code: 400
          }));
        } else {
          this.customerService.checkIban(this.form.get('iban').value).subscribe(response => {
            const accountBankInformation =  {
              iban: this.form.get('iban').value,
              bic: this.form.get('bic').value
            };
            this.accountBankInformation.emit(accountBankInformation);
          }, error => {
            this.store.dispatch(new GetAlertMessage({
              message: 'L\'IBAN saisie n\'est pas valide.',
              code: 400
            }));
          });
        }
      } else {
        this.goNexStep();
      }
    }
  }
  getError(formControlName: string): string {
    let errorMsg = '';
    if (this.form.controls[formControlName].invalid) {
      Object.keys(this.form.controls[formControlName].errors).map(
          key => {
            errorMsg = this.errors[formControlName][key];
          }
      );
    }
    return errorMsg;
  }

  goNexStep() {
    const accountBankInformation =  {
      iban: null,
      bic: null
    };
    this.accountBankInformation.emit(accountBankInformation);
  }

  setSepa($event) {
    this.genSepa = $event.target.checked;
  }
}
